<template>
    <div class="slider-choice">
        <question :text="$t(item.text)" />
        <b-row>
            <b-col cols="12" sm="10" md="10" lg="10" xl="8" class="mx-auto">
                <b-row
                    v-if="barValues"
                    class="slider-choice__box-wrapper d-flex justify-content-between"
                >
                    <b-col
                        cols="5" sm="5" md="4"
                        class="slider-choice__box"
                        v-for="(choice, i) in choices"
                        :key="'slider-choice-'+i"
                    >
                        <div class="slider-choice__bar-label">
                            {{ $t(choice.text) }}
                        </div>
                        <div class="mx-auto slider-choice__bar">
                            <simple-bar
                                :value="barValues[i]"
                                :color="baseColor"
                            />
                        </div>
                    </b-col>
                </b-row>
                <slider
                    start="center"
                    :range="sliderRange"
                    @change="handleChange"
                    :showLabels="false"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import slider from '@/components/inputs/slider'
import question from '@/components/ui/question'
import simpleBar from '@/components/ui/simpleBar'
import colorVariantMixin from '@/components/mixins/colorVariantMixin'

export default {
  name: 'sliderChoiceItem',
  components: {
    question,
    slider,
    'simple-bar': simpleBar,
  },
  mixins: [colorVariantMixin],
  props: {
      item: {
          type: Object
      }
  },
  data() {
      return {
          barValues: [50, 50],
      }
  },
  computed: {
      sliderRange() {
        return [this.item.scaleMin, this.item.scale];
      },
      choices() {
        // sort choices to ensure correct order
        return this.item.choices.sort((a, b) => {
          if (a < b) {
            return -1;
          }
          if (a > b) {
            return 1;
          }
          return 0;
        })
      }
  },
  methods: {
      handleChange(value) {
        this.barValues = this.convertResultToBarValue(value)

        const result = this.choices.map(({ order: choice }) => {
            const result = choice === 1 ? -value : value
            return {
                choice,
                result
            }
        })

        this.$emit('answer', result)
    },
    convertResultToBarValue(value) {
        let newValues = [50, 50]

        if (value > 0) {
            newValues[0] = 50 - value / 2;
            newValues[1] = 50 + value / 2;
        } else if (value < 0) {
            newValues[0] = 50 + value / -2;
            newValues[1] = 50 - value / -2;
        }

        newValues[0] = Math.round(newValues[0]);
        newValues[1] = Math.round(newValues[1]);

        // make sure rounded results always add up to 100
        if(newValues[0] + newValues[1] > 100) {
            newValues[1] = newValues[1] - (newValues[0] + newValues[1] - 100);
        }

        return newValues
    }
  }
};
</script>
<style lang="scss">

    .slider-choice__box {
        width: 40%;
    }

    .slider-choice__bar {
        height: 150px;
    }

    .slider-choice__bar-label {
        margin-bottom: 0.625em;
        height: 2.75em;
        text-align: center;
    }

</style>
